import Api from './api';

class DataService {

  getLanguage(){
    
  }

  async getDataList(filters) {
    try {
      let res = await Api.get('documentation-hub/filter?', { params: filters });
      return res.body;
    } catch (error) {
      throw error;
    }
  }

  async getDataDetail(id) {
    try {
      let res = await Api.get('documentation-hub/' + id);
      return res.body.data;
    } catch (error) {
    }
  }

  async getCategories() {
    try {
      let res = await Api.get('documentation-hub-categories');
      return res.body.data;
    } catch (error) {
    }
  }
}

export default new DataService();



// WEBPACK FOOTER //
// ./src/api/dataService.js